import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import { Container } from "../global"

const Footer = () => (
  <FooterWrapper id="footer">
    <FooterColumnContainer>
      <FooterColumn>
        <span>Links</span>
        <ul>
          <li>
            <Link to="/privacy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/terms">Terms of Service</Link>
          </li>
        </ul>
      </FooterColumn>
      <FooterColumn>
        <span>Support</span>
        <ul>
          <li>
            <Link to="/subscriptions">Support</Link>
          </li>
        </ul>
      </FooterColumn>
      <FooterColumn>
        <span>Learn more</span>
        <ul>
          <li>
            <Link to="https://www.twitter.com/theschnaz">@TheSchnaz</Link>
          </li>
          <li>
            <Link to="/whitepaper">Whitepapers</Link>
          </li>
          <li>
            <Link to="https://www.stitcher.com/show/the-nobcast/episode/ep-23-earn-bitcoin-in-your-daily-practice-with-the-dailyness-app-featuring-the-schnaz-202398772">TheSchnaz on The Nobcast</Link>
          </li>
        </ul>
      </FooterColumn>
    </FooterColumnContainer>
  </FooterWrapper>
)

const FooterWrapper = styled.footer`
  padding:80px;
  margin-bottom:80px;
  margin-top:80px;
  background-color: #f8f8f8;
`
const FooterColumnContainer = styled(Container)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 32px;
  justify-content: start;
  @media (max-width: ${(props) => props.theme.screen.sm}) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 32px;
  }
`
const FooterColumn = styled.div`
  span {
    font-size: 16px;
    font-family: ${(props) => props.theme.font.bold};
    color: ${(props) => props.theme.color.primary};
  }
  ul {
    list-style: none;
    margin: 16px 0;
    padding: 0;
    color: ${(props) => props.theme.color.black.regular};
    li {
      margin-bottom: 12px;
      font-family: ${(props) => props.theme.font.normal};
      font-size: 15px;
    }
  }
`

export default Footer
